import { ThemeColors } from '../../../'

export interface CallsListViewColors {
  ScrollingList: {
    Item: {
      Title: {
        FontColor_Missed: ThemeColors
      }
      DateTimeFontColor: ThemeColors
      Icon: {
        Default: ThemeColors
        Missed: ThemeColors
      }
    }
  }
}

export const callsListViewColors: CallsListViewColors = {
  ScrollingList: {
    Item: {
      Title: {
        FontColor_Missed: {
          default: 'red.solid',
        },
      },
      DateTimeFontColor: {
        default: 'fg.subtle',
      },
      Icon: {
        Default: {
          default: 'fg.muted',
        },
        Missed: {
          default: 'red.solid',
        },
      },
    },
  },
}
